import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconEco$1 = /*@__PURE__*/ proxyCustomElement(class WppIconEco extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-eco", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M7.35294 4.61768H17.4118C17.4605 4.61768 17.5 4.65718 17.5 4.70591V10.5294C17.5 13.2096 15.3273 15.3824 12.6471 15.3824H2.58824C2.5395 15.3824 2.5 15.3429 2.5 15.2941V9.47061C2.5 6.79041 4.67274 4.61768 7.35294 4.61768ZM1 9.47061C1 5.96198 3.84431 3.11768 7.35294 3.11768H17.4118C18.2889 3.11768 19 3.82875 19 4.70591V10.5294C19 14.0381 16.1557 16.8824 12.6471 16.8824H2.58824C1.71108 16.8824 1 16.1713 1 15.2941V9.47061ZM13.6663 7.5C12.6538 7.5 11.833 8.32081 11.833 9.33333V10.8C11.833 11.8125 12.6538 12.6333 13.6663 12.6333C14.6789 12.6333 15.4997 11.8125 15.4997 10.8V9.33333C15.4997 8.32081 14.6789 7.5 13.6663 7.5ZM12.933 9.33333C12.933 8.92832 13.2613 8.6 13.6663 8.6C14.0714 8.6 14.3997 8.92832 14.3997 9.33333V10.8C14.3997 11.205 14.0714 11.5333 13.6663 11.5333C13.2613 11.5333 12.933 11.205 12.933 10.8V9.33333ZM7.7998 9.34379C7.7998 8.32549 8.6253 7.5 9.6436 7.5H9.69251C10.4385 7.5 11.1047 7.96667 11.3597 8.66772C11.4303 8.86204 11.4665 9.0672 11.4665 9.27396V9.31042C11.4665 9.61417 11.2202 9.86042 10.9165 9.86042C10.6127 9.86042 10.3665 9.61417 10.3665 9.31042V9.27396C10.3665 9.19541 10.3527 9.11747 10.3259 9.04364C10.229 8.7773 9.97591 8.6 9.69251 8.6H9.6436C9.23281 8.6 8.8998 8.93301 8.8998 9.34379V10.7895C8.8998 11.2003 9.23281 11.5333 9.6436 11.5333H9.69251C9.97591 11.5333 10.229 11.356 10.3259 11.0897C10.3527 11.0159 10.3665 10.9379 10.3665 10.8594V10.8229C10.3665 10.5192 10.6127 10.2729 10.9165 10.2729C11.2202 10.2729 11.4665 10.5192 11.4665 10.8229V10.8594C11.4665 11.0661 11.4303 11.2713 11.3597 11.4656C11.1047 12.1667 10.4385 12.6333 9.69251 12.6333H9.6436C8.6253 12.6333 7.7998 11.8078 7.7998 10.7895V9.34379ZM5.05 7.5C4.74624 7.5 4.5 7.74624 4.5 8.05V12.0833C4.5 12.3871 4.74624 12.6333 5.05 12.6333H6.88333C7.18709 12.6333 7.43333 12.3871 7.43333 12.0833C7.43333 11.7796 7.18709 11.5333 6.88333 11.5333H5.6V10.6167H6.88333C7.18709 10.6167 7.43333 10.3704 7.43333 10.0667C7.43333 9.76291 7.18709 9.51667 6.88333 9.51667H5.6V8.6H6.88333C7.18709 8.6 7.43333 8.35376 7.43333 8.05C7.43333 7.74624 7.18709 7.5 6.88333 7.5H5.05Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-eco-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-eco", "wpp-icon-eco-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-eco-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-eco-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconEco$1);
      }
      break;
  } });
}

const WppIconEco = WppIconEco$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconEco, defineCustomElement };
